import React from 'react'
import { PieChart } from 'react-minimal-pie-chart';

function ChartPie( props ) {
  return (
    <PieChart 
        animate
        animationDuration={500}
        animationEasing="ease-out"
        center={[50, 50]}
        data={props.data}
        label={ ({ dataEntry }) => (dataEntry.percentage).toFixed(1) +'%' }
        labelPosition={65}
        labelStyle={{
            fontSize: "6px",
            fontColor: "FFFFFA",
            fontWeight: "800",
        }}
        lengthAngle={360}
        lineWidth={50}
        paddingAngle={0}
        radius={50}
        
        onMouseOver={props.onMouseOver}
        onMouseOut={props.onMouseOut}
        startAngle={0}
        viewBoxSize={[100, 100]}
    />
  )
}

export default ChartPie
